import { Link, NavLink, Outlet } from "react-router-dom";
import useLabels from "../../hooks/useLabels";

const SITE_URL = "https://wine2trace.com/";
const CONTACTS_URL = "https://www.dainese-technology.it/contatti/";
const COMPANY_LINE = "© Dainese Srl · Piazza Giorgio La Pira, 53022 Buonconvento (SI) · P.IVA 01130950528";

// Layout of the public legal pages (/privacy, /cookie, /set-cookie): same look as the static landing page
// (apps/landing), no hero photo. It does not use `.main_container`, which is what paints the hero.
// Styles: styles/shared/_legal_page.scss. Labels are the public ones (see the keys below).
const LegalLayout = () => {
  const [getLabel] = useLabels();
  const pages = [
    { to: "/privacy", label: getLabel("privacy_title") },
    { to: "/cookie", label: getLabel("cookie_title") },
    { to: "/set-cookie", label: getLabel("legal_cookie_settings_link") },
  ];

  return (
    <div className="legal_layout">
      <header className="legal_layout_header">
        <div className="legal_layout_container legal_layout_header_row">
          <a className="legal_layout_brand" href={SITE_URL}>
            {/* W2T symbol: same paths as the ui Loader */}
            <svg className="legal_layout_mark" viewBox="0 0 184 160" aria-hidden="true" focusable="false">
              <path className="legal_layout_mark_ring" d="M49.4 34.4 A72.6 72.6 0 1 1 42 45.2" />
              <path className="legal_layout_mark_wine" d="M61.1 117.6 L124 81 L6.5 12.5 L6.5 149.5 L41.2 129.3" />
            </svg>
            <span>Wine2Trace®</span>
          </a>
          <Link className="legal_layout_login" to="/login">
            {getLabel("legal_header_login")}
          </Link>
        </div>
      </header>

      <main className="legal_layout_main">
        <div className="legal_layout_container">
          <Outlet />
        </div>
      </main>

      <footer className="legal_layout_footer">
        <div className="legal_layout_container legal_layout_footer_row">
          <p className="legal_layout_company">{COMPANY_LINE}</p>
          <nav aria-label={getLabel("legal_related_pages")}>
            <ul className="legal_layout_links">
              <li>
                <a href={CONTACTS_URL}>{getLabel("legal_footer_contacts")}</a>
              </li>
              {pages.map(({ to, label }) => (
                <li key={to}>
                  <NavLink to={to}>{label}</NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default LegalLayout;
